import { render, staticRenderFns } from "./PasswordRenewal.vue?vue&type=template&id=0bbec2ba&"
import script from "./PasswordRenewal.vue?vue&type=script&lang=js&"
export * from "./PasswordRenewal.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRenewal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VFlex,VLayout,VSnackbar,VTextField})
